module.exports = __webpack_public_path__ + "img/14a246f1a7bac093e799eecaa3fdaa8a.0ad44c61.png";